'use strict';

import Vue from 'vue';

export function loadComponent(elName, config) {
    if (window && !window.usePrototypeWidgets) {
        Vue.component(elName, config);
    }
}
